module.exports = __webpack_public_path__ + "ionicons.c037dbbc0e6790f30e82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ionicons/fonts/ionicons.svg?v=2.0.0
// module id = 800
// module chunks = 8